export enum ActiveLocationFilterType {
  TYPE = 'types',
  CATEGORY = 'categories',
  COST_CENTER = 'costCenters',
  ORGANISATION = 'organisations',
  LABEL = 'labels',
  MATCH_ALL_LABELS = 'matchAllLabels',
}
